"use client";
import React from "react";
interface AnimatedLeaderboardHeaderGraphicProps {
  type: "fire" | "ice";
}
export default function AnimatedLeaderboardHeaderGraphic(
  props: AnimatedLeaderboardHeaderGraphicProps
) {
  const [animate, setAnimate] = React.useState<boolean>(false);
  React.useEffect(() => {
    setAnimate(true);
  }, []);
  const classes: string = `z-0 absolute bg-cover bg-no-repeat w-[80%] sm:w-[60%] md:w-[50%] lg:w-[35%] h-full duration-1000 ease-in-out transition-all  ${props.type === "fire" ? '-left-24 bg-right mix-blend-screen' : '-right-24 bg-left'} mix-blend-screen`;
  const bg: string = `${props.type === "fire" ? '/images/ui/fire.png' : '/images/ui/ice.png'}`
  return (
    <div className={classes} style={{backgroundImage: `url("${bg}")`, transform: `${animate ? 'translateX(0)' : (props.type === "fire" ? 'translateX(-25%)' : 'translateX(25%)')}`}}></div>
  );
}
